import '@hotmart/cosmos/dist/form/form.css'
import '@hotmart/cosmos/dist/form/input-custom.css'
import '@hotmart/cosmos/dist/form/input-switch.css'
import { useEffect, useRef } from 'react'

import useTranslation from '@space-core/hooks/useTranslation'
import { useForm } from '@space-shell/common/hooks/useForm'

import type { FormFields } from '../../types'

const BlockCommentsSelector = () => {
  const { t } = useTranslation()
  const inputRef = useRef<HTMLInputElement>(null)
  const { data: formData, setFormData } = useForm<FormFields>()

  useEffect(() => {
    if (!inputRef?.current) return

    if (formData.defaultEnableComments.value === false) {
      inputRef.current.checked = true

      return
    }

    inputRef.current.checked = false
  }, [formData.defaultEnableComments.value])

  const handleChange = () => {
    setFormData('defaultEnableComments', inputRef.current?.checked ? false : true)
  }

  return (
    <div className='_mt-5 _border _rounded-lg _py-3 _px-5 _d-flex _align-items-center'>
      <div className='_mr-4'>
        <span className='_d-block _mb-1 _line-height _text-gray-900'>
          {t('block_comments.title')}
        </span>

        <span className='_text-1 _line-height _text-gray-900'>
          {t('block_comments.description')}
        </span>
      </div>

      <div className='_ml-auto hot-form-group'>
        <div className='hot-form hot-form--custom hot-form--switch'>
          <input
            ref={inputRef}
            onChange={handleChange}
            type='checkbox'
            className='hot-form__input'
            id='block-comments-switch-space'
          />

          <label className='hot-form__label' htmlFor='block-comments-switch-space'>
            <span className='_sr-only'>{t('block_comments.title')}</span>
          </label>
        </div>
      </div>
    </div>
  )
}

export default BlockCommentsSelector
